import Rollbar from 'rollbar';
import { isIgnorableNetworkError, isSentToRollbar } from './utils';
import { isApolloError } from '@apollo/client';

const rollbarConfig = {
  accessToken: '24b46d0231094057b97b0b085a1510fd',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: process.env.SERVER_ENV
  },
  enabled: process.env.ENABLE_ROLLBAR,
  scrubFields: ['password', 'value', 'token', 'variables'],
  checkIgnore: (isUncaught, args, payload) => {
    // 明示的に送信したイベントは必ず送る
    if (!isUncaught) {
      return false;
    }

    for (const arg of args) {
      if (isSentToRollbar(arg)) {
        return true;
      }
      if (arg instanceof Error) {
        if (isApolloError(arg)) {
          const err = arg.graphQLErrors[0];
          // extensions.codeの付いているGraphQLErrorは無視
          if (err?.extensions?.code) {
            return true;
          }
        }
        if (isIgnorableNetworkError(arg)) {
          return true;
        }
      }
    }

    return false;
  }
};

Rollbar.init(rollbarConfig);

window.rollbar = Rollbar;

declare global {
  // eslint-disable-next-line no-var
  var rollbar: Rollbar;
}
